export function lazy<T>(f: () => T): () => T {
  let result: T;
  return () => {
    if (f) {
      result = f();
      f = undefined!;
    }
    return result;
  };
}

export function lazyAsyncFunction<T extends Function>(f: () => Promise<T>): T {
  let result: T;
  return <any>async function (this: any) {
    if (f) {
      result = await f();
      f = undefined!;
    }
    return result.apply(this, arguments);
  };
}
